<template>
  <v-app>
    <v-main class="pt-0">
      <v-parallax class="mb-6 hero-parallax" dark src="@/assets/img/hcl-hero-new.png" height="450">
        <v-row align="center" justify="end">
          <v-col cols="12" md="6" sm="12">
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12" class="white--text text-center">
                <v-img :src="heroImage" max-width="150px" class="d-block ml-auto mr-auto"></v-img>
                <h1 class="font-weight-light display-2 mb-8">{{items[0].sname.toUpperCase() }}</h1>
                <h1 class="font-weight-light display-2 mb-8">{{items[0].manufacturer_name}}</h1>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-parallax>
      <v-row justify="start">
        <v-btn class="ma-2 ml-16" size="x-large" color="#041a41" @click="goToHome">
          <v-icon color="white" left>mdi-arrow-left</v-icon>
          <h3 style="color: white;">Voltar</h3>
        </v-btn>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="10" md="8" lg="6">
              <h1 v-if="items.length > 1">Modelos Homologados:</h1>
              <h1 v-else>Modelo Homologado</h1>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="mb-12">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-container>
              <v-card class="mt-12">
                <v-card-text>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="text-center">ID</th>
                        <th class="text-center">Inserção</th>
                        <th class="text-center">Distribuição / Kernel</th>
                        <th class="text-center">Certificado QA</th>
                        <th class="text-center">Especificações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ item.Data }}</td>
                        <td>{{ item.kernel }}</td>
                        <td>SIM</td>
                        <td>
                          <v-btn icon>
                              <v-icon class="icon-hover" color="blue" @click="goToModel(item.id)">mdi-magnify</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-container>
          </v-row>
        </v-col>
      </v-row>
    </v-main>
    <footerSection />
  </v-app>
</template>

<script>
import axios from '@/utils/axios';
import footerSection from "@/components/Footer";

export default {
  components: {
    footerSection
  },
  data() {
    return {
      items: [],
      loading: false,
      error: null,
      page: 1,
      total: 1,
      totalCount: 1,
      heroImage: null
    };
  },
  created() {
    this.heroImage = require(`@/assets/img/configuration.png`);
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
    this.fetchModels();
  },
  methods: {
    updatePage(page) {
      this.$router.push({
        path: this.$route.path,
        query: { vendor: this.vendor, page: page }
      });
      this.fetchModels();
    },

    goToHome() {
      this.$router.go(-1);
    },
    goToModel(id){
      this.$router.push(`/certificado/modelo/${id}`);
    },
    async fetchModels() {
      this.loading = true;
      let response;
      try {
        response = await axios.get(`/api/getModelConf.php?id=${this.$route.params.pathMatch}`);
        this.items = response.data;
        this.total = response.data.totalPages;
        this.totalCount = response.data.totalCount;
      } catch (error) {
        console.error('Error:', error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style>
.icon-hover:hover {
  color: blue;
}
</style>
